import React, { useEffect } from "react";
import { Route, Redirect } from "react-router-dom";
import PreCheckInHome from "../precheckin/PreCheckInHome";
import BookDetail from "../precheckin/BookDetail";
import OtherBookDetail from "../precheckin/OtherBookDetail";
import GuestInfo from "../precheckin/GuestInfo";
import GuestDataCollection from "../precheckin/GuestDataCollection";
import GuestConfirmDataCollection from "../precheckin/GuestConfirmDataCollection";
import AdditionalInformation from "../precheckin/AdditionalInformation";
import PickupKeys from "../precheckin/PickupKeys";
import CardList from "../precheckin/CardList";
import NewCard from "../precheckin/NewCard";
import Confirmation from "../precheckin/Confirmation";
import GuestListManagement from "../precheckin/GuestListManagement";
import AddGuest from "../precheckin/AddGuest";
import AddMyChild from "../precheckin/AddMyChild";
import AddAdult from "../precheckin/AddAdult";
import AddAdultWithChild from "../precheckin/AddAdultWithChild";
import RegisterGuest from "../precheckin/RegisterGuest";
import ChooseGuestsToRegister from "../precheckin/ChooseGuestsToRegister";
import PreAuthDropin from "../finishorder/PreAuthDropin";
import { usePreCheckInContext } from "../precheckin/contexts/PreCheckInContext";
import AddressCollection from "../precheckin/AddressCollection";
import AddYourselfToTrip from "../precheckin/AddYourselfToTrip";
import Preferences from "../precheckin/Preferences";
import { isEmpty } from "lodash";

const PreCheckInRouteWrapper = ({ component: Component, ...props }) => {
  const {
    data: { presets },
    func: { initialPreCheckIn },
  } = usePreCheckInContext();

  useEffect(() => {
    initialPreCheckIn(props);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (presets) {
      if (!isEmpty(presets.app_webstore_favicon_url)) {
        const favicon = document.getElementById("favicon");
        if (favicon) favicon.href = presets.app_webstore_favicon_url;
        const appleFavicon = document.getElementById("apple-favicon");
        if (appleFavicon) appleFavicon.href = presets.app_webstore_favicon_url;
      }
      const desktopContainer = document.getElementById("desktop-container");
      if (!isEmpty(presets.app_home_webapp_desktop_bg) && desktopContainer) {
        desktopContainer.style.backgroundColor =
          presets.app_home_webapp_desktop_bg;
      }
      const root = document.getElementById("root");
      const tabletContainer = document.getElementById("tablet-container");
      const wrapper = tabletContainer ? tabletContainer : root;
      if (wrapper) {
        if (props.requestCompleted) {
          wrapper.style.backgroundColor = presets.backgroundColorTopBar;
          wrapper.style.height = "100%";
        } else if (!isEmpty(presets.app_home_global_background_color)) {
          wrapper.style.backgroundColor =
            presets.app_home_global_background_color;
        }
      }
    }
  }, [presets, props.requestCompleted]);

  return <Component {...props} />;
};

function PreCheckInApp() {
  return (
    <>
      <Route
        exact
        path="/pre-checkin/:propertyUid"
        render={(props) => {
          const { match, location } = props;
          const { propertyUid } = match.params;
          const { search } = location;
          return <Redirect to={`/pre-checkin/${propertyUid}/home${search}`} />;
        }}
      />
      <Route
        exact
        home="true"
        path={"/pre-checkin/:propertyUid/home"}
        component={(routeProps) => (
          <PreCheckInRouteWrapper
            component={PreCheckInHome}
            home
            noCache={true}
            bookingType="home"
            {...routeProps}
          />
        )}
      />
      <Route
        exact
        path={"/pre-checkin/:propertyUid/booking-code"}
        component={(routeProps) => (
          <PreCheckInRouteWrapper
            component={PreCheckInHome}
            bookingType="BookingNumber"
            {...routeProps}
          />
        )}
      />
      <Route
        exact
        path={"/pre-checkin/:propertyUid/guest-name"}
        component={(props) => (
          <PreCheckInRouteWrapper
            component={PreCheckInHome}
            bookingType="GuestName"
            {...props}
          />
        )}
      />
      <Route
        exact
        path={"/pre-checkin/:propertyUid/guest-email"}
        component={(props) => (
          <PreCheckInRouteWrapper
            component={PreCheckInHome}
            bookingType="GuestEmail"
            {...props}
          />
        )}
      />
      <Route
        exact
        path="/pre-checkin/:propertyUid/book-detail"
        render={(props) => {
          const { match, location } = props;
          const { propertyUid } = match.params;
          const { search } = location;
          return <Redirect to={`/pre-checkin/${propertyUid}/home${search}`} />;
        }}
      />
      <Route
        exact
        path={"/pre-checkin/:propertyUid/book-detail/:bookingNumber"}
        component={(routeProps) => (
          <PreCheckInRouteWrapper
            component={BookDetail}
            reset={true}
            {...routeProps}
          />
        )}
      />
      <Route
        exact
        path={"/pre-checkin/:propertyUid/book-detail/:bookingNumber/:lastName"}
        component={(routeProps) => (
          <PreCheckInRouteWrapper
            component={BookDetail}
            {...routeProps}
          />
        )}
      />
      <Route
        exact
        path={[
          "/pre-checkin/:propertyUid/upcoming-stays/:bookingType/:bookingInput/:checkInBookingDate",
          "/pre-checkin/:propertyUid/upcoming-stays/:bookingType/:bookingInput",
        ]}
        component={(routeProps) => (
          <PreCheckInRouteWrapper
            component={OtherBookDetail}
            reset={true}
            enableUpcomingStays
            {...routeProps}
          />
        )}
      />
      <Route
        exact
        path={
          "/pre-checkin/:propertyUid/book-detail/:bookingNumber/guests/:guestNumber/data-collection"
        }
        component={(routeProps) => (
          <PreCheckInRouteWrapper
            component={GuestDataCollection}
            {...routeProps}
          />
        )}
      />
      <Route
        exact
        path={
          "/pre-checkin/:propertyUid/book-detail/:bookingNumber/guests/:guestNumber/address-collection"
        }
        component={(routeProps) => (
          <PreCheckInRouteWrapper
            component={AddressCollection}
            {...routeProps}
          />
        )}
      />
      <Route
        exact
        path={
          "/pre-checkin/:propertyUid/book-detail/:bookingNumber/guests/:guestNumber/confirm"
        }
        component={(routeProps) => (
          <PreCheckInRouteWrapper
            component={GuestConfirmDataCollection}
            {...routeProps}
          />
        )}
      />
      <Route
        exact
        path={
          "/pre-checkin/:propertyUid/book-detail/:bookingNumber/guests/:guestNumber/steps/:step"
        }
        component={(routeProps) => (
          <PreCheckInRouteWrapper
            component={GuestInfo}
            {...routeProps}
          />
        )}
      />
      <Route
        exact
        path={
          "/pre-checkin/:propertyUid/book-detail/:bookingNumber/guests/:guestNumber/preferences"
        }
        component={(routeProps) => (
          <PreCheckInRouteWrapper
            component={Preferences}
            {...routeProps}
          />
        )}
      />
      <Route
        exact
        path={
          "/pre-checkin/:propertyUid/booking/:bookingNumber/additional-information"
        }
        component={(routeProps) => (
          <PreCheckInRouteWrapper
            component={AdditionalInformation}
            {...routeProps}
          />
        )}
      />
      <Route
        exact
        path={"/pre-checkin/:propertyUid/booking/:bookingNumber/pickup-keys"}
        component={(routeProps) => (
          <PreCheckInRouteWrapper
            component={PickupKeys}
            {...routeProps}
          />
        )}
      />
      <Route
        exact
        path={"/pre-checkin/:propertyUid/booking/:bookingNumber/cards"}
        component={(routeProps) => (
          <PreCheckInRouteWrapper
            component={CardList}
            {...routeProps}
          />
        )}
      />
      <Route
        exact
        path={"/pre-checkin/:propertyUid/booking/:bookingNumber/cards/new"}
        component={(routeProps) => (
          <PreCheckInRouteWrapper
            component={NewCard}
            {...routeProps}
          />
        )}
      />
      <Route
        exact
        path={
          "/pre-checkin/:propertyUid/booking/:bookingNumber/request-completed"
        }
        component={(routeProps) => (
          <PreCheckInRouteWrapper
            requestCompleted={true}
            component={Confirmation}
            {...routeProps}
          />
        )}
      />
      <Route
        exact
        path={
          "/pre-checkin/:propertyUid/guest-list-management/:bookingNumber/:lastName"
        }
        component={(routeProps) => (
          <PreCheckInRouteWrapper
            component={GuestListManagement}
            reset={true}
            {...routeProps}
          />
        )}
      />
      <Route
        exact
        path={"/pre-checkin/:propertyUid/guest-list-management/:bookingNumber"}
        component={(routeProps) => (
          <PreCheckInRouteWrapper
            component={GuestListManagement}
            reset={true}
            {...routeProps}
          />
        )}
      />
      <Route
        exact
        path={
          "/pre-checkin/:propertyUid/guest-list-management/:bookingNumber/:lastName/add-guest"
        }
        component={(routeProps) => (
          <PreCheckInRouteWrapper
            component={AddGuest}
            {...routeProps}
          />
        )}
      />
      <Route
        exact
        path={
          "/pre-checkin/:propertyUid/guest-list-management/:bookingNumber/:lastName/add-my-child"
        }
        component={(routeProps) => (
          <PreCheckInRouteWrapper
            component={AddMyChild}
            {...routeProps}
          />
        )}
      />
      <Route
        exact
        path={
          "/pre-checkin/:propertyUid/guest-list-management/:bookingNumber/:lastName/add-adult"
        }
        component={(routeProps) => (
          <PreCheckInRouteWrapper
            component={AddAdult}
            {...routeProps}
          />
        )}
      />
      <Route
        exact
        path={
          "/pre-checkin/:propertyUid/guest-list-management/:bookingNumber/:lastName/add-adult-with-child"
        }
        component={(routeProps) => (
          <PreCheckInRouteWrapper
            component={AddAdultWithChild}
            {...routeProps}
          />
        )}
      />
      <Route
        exact
        path={
          "/pre-checkin/:propertyUid/guest-list-management/:bookingNumber/:lastName/register-guest"
        }
        component={(routeProps) => (
          <PreCheckInRouteWrapper
            component={RegisterGuest}
            {...routeProps}
          />
        )}
      />
      <Route
        exact
        path={
          "/pre-checkin/:propertyUid/guest-list-management/:bookingNumber/:lastName/choose-guests-to-register"
        }
        component={(routeProps) => (
          <PreCheckInRouteWrapper
            component={ChooseGuestsToRegister}
            {...routeProps}
          />
        )}
      />

      <Route
        exact
        path={
          "/pre-checkin/:propertyUid/booking/:bookingNumber/pre-auth-dropin"
        }
        component={(routeProps) => (
          <PreCheckInRouteWrapper
            component={PreAuthDropin}
            {...routeProps}
          />
        )}
      />

      <Route
        exact
        path={
          "/pre-checkin/:propertyUid/guest-list-management/:bookingNumber/:lastName/add-yourself-to-trip"
        }
        component={(routeProps) => (
          <PreCheckInRouteWrapper
            component={AddYourselfToTrip}
            {...routeProps}
          />
        )}
      />
    </>
  );
}

export default PreCheckInApp;
